import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringOrDefault'
})
export class StringOrDefaultPipe implements PipeTransform {
  transform(value: any, defaultString?: string): string {
    let formattedString: string = '—'; // default to an em dash

    if (typeof defaultString !== 'undefined') {
      formattedString = defaultString; // override default
    }

    if (value !== null && typeof value === 'string' && value !== '') {
      formattedString = value;
    }

    return formattedString;
  }
}
